import { Link } from '@tanstack/react-router'
import { ArrowLeft } from 'lucide-react'

import type { ImportBasePath, ImportParentPath } from '../types'

export function ImportBackLink({
  to,
  label,
}: {
  to: ImportBasePath | ImportParentPath
  label: string
}) {
  return (
    <Link
      to={to}
      className="text-muted-foreground hover:text-foreground mb-6 inline-flex items-center gap-1.5 text-sm"
    >
      <ArrowLeft className="h-4 w-4" />
      {label}
    </Link>
  )
}
